import {Injectable} from "@angular/core";
import {NavigationEnd, Router } from "@angular/router";
import { environment } from "src/environments/environment";

declare var gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsHelper {
  constructor(private router: Router) {}

  private onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects,
        });
      }
    });
  }

  public initialize() {
    this.onRouteChange();

    // dynamically add analytics scripts to document head
    try {
      const url = 'https://www.googletagmanager.com/gtag/js?id=';
      const gTagScript = document.createElement('script');
      gTagScript.async = true;
      gTagScript.setAttribute("data-cookie-consent", "tracking");
      gTagScript.src = `${url}${environment.googleAnalyticsId}`;
      document.head.appendChild(gTagScript);

      const dataLayerScript = document.createElement('script');
      dataLayerScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${environment.googleAnalyticsId}', {'send_page_view': false});`;
      document.head.appendChild(dataLayerScript);
    } catch (e) {
      console.error('Error adding Google Analytics', e);
    }
  }

  public addDownloadEvent(docId: string | null, typeMime: String) {
    docId = docId || 'unknown';
    gtag('event', 'download_docs', {
      'document_type_mime': typeMime,
      'event_label': 'Document Download',
      'document_id': docId
    });
  }

  public event(action: string, eventCategory?: string, eventLabel?: string, value?: string) {
    gtag('event', action, {
      ...(eventCategory && { event_category: eventCategory }),
      ...(eventLabel && { event_label: eventLabel }),
      ...(value && { value: value }),
    });
  }

}
